import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  AccessControl,
  PermissionRequired,
  //@ts-ignore
} from "@careinfo/permission-required";
import CreateDelivery from "../pages/Delivery/CreateDelivery";
import DeliveryList from "../pages/Delivery/DeliveryList";
import EditDelivery from "../pages/Delivery/EditDelivery";
export const queryClient = new QueryClient();

const Router = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <HashRouter>
        <Routes>
          <Route
            path="/"
            element={
              <AccessControl
                children={<DeliveryList />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/delivery"
            element={
              <AccessControl
                children={<DeliveryList />}
                allowedPermissions={["can_view_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/create"
            element={
              <AccessControl
                children={<CreateDelivery />}
                allowedPermissions={["can_create_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
          <Route
            path="/edit/:id"
            element={
              <AccessControl
                children={<EditDelivery />}
                allowedPermissions={["can_editupdate_runsheet"]}
                renderNoAccess={<PermissionRequired />}
              />
            }
          />
        </Routes>
      </HashRouter>
      <ToastContainer autoClose={1000} draggablePercent={30} />
    </QueryClientProvider>
  );
};

export default Router;
